var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.selectedOption
    ? _c("div", { staticClass: "your-selection p-4" }, [
        _c("strong", [
          _vm._v("You have "),
          _c("span", [
            _vm._v(_vm._s(_vm.isAddition ? "selected" : "deselected"))
          ]),
          _vm._v(":")
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "option d-flex justify-content-between" }, [
          _c("div", {
            staticClass: "label d-flex flex-column justify-content-center",
            domProps: { innerHTML: _vm._s(_vm.getName(_vm.selectedOption)) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "cost" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("numeral")(_vm.getCost(_vm.selectedOption), "$0,0")
                ) +
                "\n        "
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }